import {PageView} from "./PageView.js";
import {SignUpViewChanger} from "../util/view-changer/index.js";
import {Header} from "../components/Header.js";
import {GoogleButton} from "../components/button/GoogleButton.js";
import {getPlanId} from "../store.js";
import {BusinessSnsLayout} from "../components/layout/BusinessSnsLayout.js";
import {EmailButton} from "../components/button/EmailButton.js";

export class BusinessSnsView extends PageView {
    renderLayout() {
        const {mainText = '', subText = ''} = this.$props;
        this.$props.Layout = new BusinessSnsLayout(this.$target, {
            isAppend : true,
            sectionId : 'snsInputSection',
            mainText,
            subText,
            nextLink : {
                id: "nextLink",
                isView : Mutil.exist(window.CONNECT_INVITE_KEY),
                text :  i18next.t(login.startAsAGuest),
                isBottom : true,
                nextPageFunc: () => {
                    SignUpViewChanger.loadGuestEmailView(getPlanId());
                }
            }
        })
    }
    renderComponents() {
        if(!this.$props.Layout) {
            return;
        }
        const googleButtonId = "googleLoginButton";
        new Header(this.$props.Layout.getHeaderLayer(), {
            isShowLoginBtn : true,
            isShowPrevBtn : true
        });
        new GoogleButton(this.$props.Layout.getMainLayer(), {
            type : 'button',
            id: googleButtonId,
            isAfter : true,
            $posTarget : this.$props.Layout.getSubTextLayer()
        });

        new EmailButton(this.$props.Layout.getMainLayer(), {
            isAfter : true,
            buttonText : i18next.t(login.emailstrt),
            $posTarget : $(`#${googleButtonId}`),
            clickFunc : () => {
                if(Often.isGlobal()) {
                    SignUpViewChanger.loadMorningMateBusinessEmailInputView()
                    return
                }

                SignUpViewChanger.loadBusinessEmailView(getPlanId());
            }
        });
    }
}